import {teamDesk} from './bowlCoverage.js'

export function schoolMemberNames(team) {
  return [...new Set(teamDesk(team).reps)]
}
export function schoolMatchesMember(team, name) {
  return !name || schoolMemberNames(team).includes(name)
}
export function schoolMemberOptions(teams) {
  return [...new Set(teams.flatMap(schoolMemberNames))].sort((a,b) => a.localeCompare(b))
}
export function schoolTeamExport(teams, season) {
  // One row per school; names remain one cell, never expanded into duplicated accounts.
  const unique = [...new Map(teams.map(t => [`${season}:${t.conference}:${t.name || t.team}`,t])).values()]
  const cell = value => `"${String(value ?? '').replace(/^[=+@\-\t\r]/,"'$&").replaceAll('"','""')}"`
  return [['Season','School','Conference','Bowl coverage people','Coverage status','CRM owner'],
    ...unique.map(t => {const desk = teamDesk(t); return [season,t.name || t.team,t.conference,desk.reps.join(' + '),desk.label,t.assignedRep || t.sr_assigned_rep || t.owner || '']})]
    .map(row => row.map(cell).join(',')).join('\r\n')
}
